import { officeTaskTypes as T } from "../actions/officeTask.actions";

const initialState = {
    tasks: [],
    selected: null,
    meta: {},
    loading: false,
    actionLoading: false,
    error: null,
    message: "",
};

const getId = (value) => String(value?._id || value?.id || value || "");

const upsertTask = (items = [], task) => {
    const id = getId(task);
    if (!id) return items;

    const exists = items.some((item) => getId(item) === id);
    if (!exists) return [task, ...items];

    return items.map((item) => getId(item) === id ? task : item);
};

export default function officeTaskReducer(state = initialState, action) {
    switch (action.type) {
        case T.LIST_REQUEST:
            return { ...state, loading: true, error: null };

        case T.LIST_SUCCESS: {
            const tasks = action.payload?.tasks || [];
            const selectedId = getId(state.selected);
            return {
                ...state,
                tasks,
                selected: selectedId
                    ? tasks.find((task) => getId(task) === selectedId) || state.selected
                    : null,
                meta: action.payload?.meta || {},
                loading: false,
                error: null,
            };
        }

        case T.LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || "Ошибка загрузки заданий",
            };

        case T.MUTATION_REQUEST:
            return { ...state, actionLoading: true, error: null };

        case T.MUTATION_SUCCESS: {
            const task = action.payload?.task || null;
            return {
                ...state,
                tasks: task ? upsertTask(state.tasks, task) : state.tasks,
                selected: task && getId(state.selected) === getId(task)
                    ? task
                    : state.selected,
                actionLoading: false,
                error: null,
                message: action.payload?.message || "",
            };
        }

        case T.MUTATION_FAILURE:
            return {
                ...state,
                actionLoading: false,
                error: action.payload?.error || "Ошибка изменения задания",
            };

        case T.SELECT:
            return { ...state, selected: action.payload || null };

        case T.CLEAR_ERROR:
            return { ...state, error: null };

        default:
            return state;
    }
}
